var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { filter: "url(#filter0_dii_2367_2415)" } }, [
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M15.3859 9.42282C15.7466 9.2718 16 8.91549 16 8.5C16 7.94772 15.5523 7.5 15 7.5C14.4477 7.5 14 7.94772 14 8.5C14 8.9155 14.2534 9.27181 14.6141 9.42282C14.4678 10.0579 14.3214 10.9437 14.175 11.8294C13.9502 13.19 13.7254 14.5502 13.501 15C13.2179 15.5672 12.6123 13.8826 12.0498 12.318L12.0498 12.318C11.8525 11.7692 11.6605 11.2351 11.4896 10.8182C11.649 10.6807 11.75 10.4771 11.75 10.25C11.75 9.83579 11.4142 9.5 11 9.5C10.5858 9.5 10.25 9.83579 10.25 10.25C10.25 10.5808 10.4642 10.8616 10.7614 10.9613C10.7419 11.2561 10.7286 11.6012 10.7143 11.971C10.6556 13.4874 10.5809 15.419 9.99955 16C9.37627 16.623 8.7535 14.9172 8.25162 13.5425C8.08824 13.0949 7.93767 12.6825 7.80407 12.3969C7.9232 12.3056 8 12.1617 8 12C8 11.7239 7.77614 11.5 7.5 11.5C7.22386 11.5 7 11.7239 7 12C7 12.2276 7.1521 12.4197 7.36021 12.4802C7.34903 13.4975 7.77844 15.8458 7.93981 16.6904C7.96334 16.8135 7.9751 16.8751 7.98257 16.9312C7.9895 16.9834 7.99382 17.0289 7.9968 17.0815C8.00001 17.138 8.00001 17.1976 8.00001 17.3168L8.00005 18.0218C8.00007 18.6418 8.00009 18.9518 8.16634 19.3336C8.28447 19.605 8.60782 20.0013 8.84991 20.1715C9.19062 20.411 9.423 20.4586 9.88775 20.5538C11.0158 20.7849 12.6869 21 15.0001 21C17.3133 21 18.9843 20.785 20.1123 20.5538C20.5771 20.4586 20.8095 20.411 21.1503 20.1715C21.3924 20.0013 21.7157 19.6049 21.8338 19.3336C22.0001 18.9517 22.0001 18.6417 22 18.0216L22 17.3172V17.3171V17.317V17.317V17.3169V17.3169C22 17.1978 22 17.1382 22.0032 17.0816C22.0062 17.029 22.0105 16.9834 22.0175 16.9311C22.0249 16.8749 22.0367 16.8133 22.0603 16.69C22.2218 15.8451 22.6514 13.4973 22.6401 12.4801C22.848 12.4196 23 12.2275 23 12C23 11.7239 22.7761 11.5 22.5 11.5C22.2239 11.5 22 11.7239 22 12C22 12.1616 22.0767 12.3054 22.1957 12.3968C22.0618 12.6826 21.911 13.0956 21.7473 13.5437C21.2454 14.9182 20.6228 16.6228 20 16C19.418 15.418 19.3427 13.4811 19.2836 11.9636V11.9636L19.2836 11.9634V11.9634V11.9634C19.2694 11.5967 19.256 11.2545 19.2368 10.9619C19.535 10.8627 19.75 10.5815 19.75 10.25C19.75 9.83579 19.4142 9.5 19 9.5C18.5858 9.5 18.25 9.83579 18.25 10.25C18.25 10.4778 18.3516 10.6819 18.5119 10.8195C18.3425 11.2337 18.152 11.7634 17.9562 12.3083L17.9562 12.3083C17.3927 13.8756 16.7842 15.5683 16.5 15C16.2749 14.5499 16.0498 13.1881 15.8247 11.8265L15.8247 11.8265C15.6784 10.9418 15.5321 10.0572 15.3859 9.42282Z",
            fill: "url(#paint0_linear_2367_2415)"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "defs",
        [
          _c(
            "filter",
            {
              attrs: {
                id: "filter0_dii_2367_2415",
                x: "6",
                y: "6.5",
                width: "20",
                height: "17.5",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB"
              }
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" }
              }),
              _vm._v(" "),
              _c("feColorMatrix", {
                attrs: {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              }),
              _vm._v(" "),
              _c("feOffset", { attrs: { dx: "1", dy: "1" } }),
              _vm._v(" "),
              _c("feGaussianBlur", { attrs: { stdDeviation: "1" } }),
              _vm._v(" "),
              _c("feColorMatrix", {
                attrs: {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                }
              }),
              _vm._v(" "),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow_2367_2415"
                }
              }),
              _vm._v(" "),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow_2367_2415",
                  result: "shape"
                }
              }),
              _vm._v(" "),
              _c("feColorMatrix", {
                attrs: {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              }),
              _vm._v(" "),
              _c("feOffset", { attrs: { dx: "1", dy: "1" } }),
              _vm._v(" "),
              _c("feGaussianBlur", { attrs: { stdDeviation: "0.5" } }),
              _vm._v(" "),
              _c("feComposite", {
                attrs: {
                  in2: "hardAlpha",
                  operator: "arithmetic",
                  k2: "-1",
                  k3: "1"
                }
              }),
              _vm._v(" "),
              _c("feColorMatrix", {
                attrs: {
                  type: "matrix",
                  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
                }
              }),
              _vm._v(" "),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in2: "shape",
                  result: "effect2_innerShadow_2367_2415"
                }
              }),
              _vm._v(" "),
              _c("feColorMatrix", {
                attrs: {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              }),
              _vm._v(" "),
              _c("feOffset", { attrs: { dx: "-1", dy: "-1" } }),
              _vm._v(" "),
              _c("feGaussianBlur", { attrs: { stdDeviation: "0.5" } }),
              _vm._v(" "),
              _c("feComposite", {
                attrs: {
                  in2: "hardAlpha",
                  operator: "arithmetic",
                  k2: "-1",
                  k3: "1"
                }
              }),
              _vm._v(" "),
              _c("feColorMatrix", {
                attrs: {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
                }
              }),
              _vm._v(" "),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in2: "effect2_innerShadow_2367_2415",
                  result: "effect3_innerShadow_2367_2415"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint0_linear_2367_2415",
                x1: "-0.83815",
                y1: "14.1134",
                x2: "12.2001",
                y2: "29.5662",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "#FFD400" } }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#FFAA00" } })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }